import React from "react";

const Privacy = () => {
  const company_privacy_policy = localStorage.getItem("company_privacy_policy");
  return (
    <>
      <div
        style={{ padding: "15px" }}
        dangerouslySetInnerHTML={{
          __html: company_privacy_policy,
        }}
      />
    </>
  );
};

export default Privacy;
